<script>
import options from './CaseCard.options'

export default {
  name: 'CaseCard',
  options,
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <a class="kb-case-card" :href="data.url">
    <div v-if="data.imageUrl" class="kb-case-card__image">
      <img :src="data.imageUrl" />
    </div>

    <div class="kb-case-card__quote-wrapper">
      <blockquote class="kb-case-card__quote">"{{ data.quote }}"</blockquote>

      <cite class="kb-case-card__quotee">
        {{ data.quotee }}
      </cite>
    </div>
  </a>
</template>
